import { TrText } from "../components/TrText";
import { TrSpace } from "../components/TrSpace";
import { TrTextField } from "../components/TrTextField";
import { FormPageButton } from "../components/FormPageButton";
import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setShippingInfo } from "../reducks/shippingInfo/operations";

export const InputShippingInfo = () => {
    const dispatch = useDispatch()

    const [receiver, setReceiver] = useState("")
    const [furigana, setFurigana] = useState("")
    const [telephone, setTelephone] = useState("")
    const [postCode, setPostCode] = useState("")
    const [prefecture, setPrefecture] = useState("")
    const [city, setCity] = useState("")
    const [address, setAddress] = useState("")
    const [apartmentAndRoom, setApartmentAndRoom] = useState("")
    const [isAlertForReceiver, setIsAlertForReceiver] = useState(false)
    const [isAlertForFurigana, setIsAlertForFurigana] = useState(false)
    const [isAlertForTelephone, setIsAlertForTelephone] = useState(false)
    const [isAlertForPostCode, setIsAlertForPostCode] = useState(false)
    const [isAlertForPrecfecture, setIsAlertForPrefecture] = useState(false)
    const [isAlertForCity, setIsAlertForCity] = useState(false)
    const [isAlertForAddress, setIsAlertForAddress] = useState(false)

    const inputReceiver = useCallback((event) => {
        setReceiver(event.target.value);
    }, [setReceiver])

    const inputFurigana = useCallback((event) => {
        setFurigana(event.target.value);
    }, [setFurigana])

    const inputTelephone = useCallback((event) => {
        setTelephone(event.target.value);
    }, [setTelephone])

    const inputPostCode = useCallback((event) => {
        setPostCode(event.target.value);
    }, [setPostCode])

    const inputPrefecture = useCallback((event) => {
        setPrefecture(event.target.value);
    }, [setPrefecture])

    const inputCity = useCallback((event) => {
        setCity(event.target.value);
    }, [setCity])

    const inputAddress = useCallback((event) => {
        setAddress(event.target.value);
    }, [setAddress])

    const inputApartmentAndRoom = useCallback((event) => {
        setApartmentAndRoom(event.target.value);
    }, [setApartmentAndRoom])

    function checkValidate() {
        if(receiver === "") {
            setIsAlertForReceiver(true);
        }else{
            setIsAlertForReceiver(false); 
        }
        
        if(furigana === "") {
            setIsAlertForFurigana(true);
        }else{
            setIsAlertForFurigana(false);
        }

        if (telephone === "") {
            setIsAlertForTelephone(true);
        } else {
            setIsAlertForTelephone(false);
        }

        if(postCode === "") {
            setIsAlertForPostCode(true);
        }else{
            setIsAlertForPostCode(false); 
        }
        
        if(prefecture === "") {
            setIsAlertForPrefecture(true);
        }else{
            setIsAlertForPrefecture(false);
        }

        if (city === "") {
            setIsAlertForCity(true);
        } else {
            setIsAlertForCity(false);
        }

        if (address === "") {
            setIsAlertForAddress(true);
        } else {
            setIsAlertForAddress(false);
        }

    }

    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>発送先情報を入力</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="iPad/iPadMini:w-11/12 md:w-6/12">
                            <tbody>
                                <TrText text="お名前"/>
                                <TrTextField id="receiver" placeholder="お名前（必須）" required={true} isAlert={isAlertForReceiver} onChange={inputReceiver}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="お名前（フリガナ）"/>
                                <TrTextField id="receiver-kana-name" placeholder="お名前（フリガナ）（必須）" required={true} isAlert={isAlertForFurigana} onChange={inputFurigana}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="電話番号"/>
                                <TrTextField id="telephone" placeholder="電話番号（必須）" required={true} isAlert={isAlertForTelephone} onChange={inputTelephone}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="郵便番号"/>
                                <TrTextField id="post-code" placeholder="郵便番号（必須）" required={true} isAlert={isAlertForPostCode} onChange={inputPostCode}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="都道府県"/>
                                <TrTextField id="prefectures" placeholder="都道府県（必須）" required={true} isAlert={isAlertForPrecfecture} onChange={inputPrefecture}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="市町村"/>
                                <TrTextField id="cities" placeholder="市町村（必須）" required={true} isAlert={isAlertForCity} onChange={inputCity}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="番地"/>
                                <TrTextField id="house-number" placeholder="番地（必須）" required={true} isAlert={isAlertForAddress} onChange={inputAddress}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="マンション名・号室"/>
                                <TrTextField id="apartment-and-room" placeholder="マンション名・号室（任意）" required={false} isAlert={false} onChange={inputApartmentAndRoom}/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <FormPageButton 
                            text="次へ進む" 
                            onClick={() => {
                                checkValidate();
                                dispatch(setShippingInfo(receiver, furigana, telephone, postCode, prefecture, city, address, apartmentAndRoom));
                            }}
                        />
                    </div>
                </main>
        </div>
    );
};